module.exports = __webpack_public_path__ + "img/SAVE_NEW.8104d8f3.svg";